import { useRoutes } from 'react-router-dom';
import AuthRoutes from './AuthRoutes';
import NonAuthRoutes from './NonAuthRoutes';
import ResetRoute from './ResetRoute';

const Routing = () => {
  const route = useRoutes([AuthRoutes, NonAuthRoutes, ResetRoute]);

  return <>{route}</>;
};

export default Routing;
